// extracted by mini-css-extract-plugin
export default {"contain":"G8c5a2c Gf8aefa"};